import { Link, useNavigate } from 'react-router-dom';

import useTranslations from '@/i18n/useTranslations';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import ArtlistImage from '@/shared-components/cards/components/ArtlistImage';
import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';
import CardHeader from '@/shared-components/cards/components/CardHeader';
import Text from '@/shared-components/text/components/Text';
import Utils from '@/utils';

import './styles/CommunityArtlistCard.css';

export default function CommunityArtlistCard({ artlist, createdAt, actor }) {
  const navigate = useNavigate();
  const t = useTranslations('common.shared.community_feed');
  const tHome = useTranslations('common.shared.home');

  const artworks = artlist.artlist_artworks || [];
  const artworksMainPictureIds = artlist.artlist_artworks_main_picture_ids || [];

  const imageMap = artworks.reduce((acc, artwork, index) => {
    const entry = artworksMainPictureIds[index];
    if (!entry) return acc;
    const imageId =
      typeof entry === "string"
        ? entry
        : entry.image_id || entry.main_picture_id || entry.imageId;
    const artworkId = typeof artwork === "string" ? artwork : artwork._id;
    if (imageId && artworkId) {
      acc[artworkId] = imageId;
    }
    return acc;
  }, {});

  const totalArtworks = artworks.length;
  const latestArtworks = artworks.slice(-7).reverse();

  const artworksWithImages = latestArtworks
    .map((artwork) => {
      const artworkId = typeof artwork === "string" ? artwork : artwork._id;
      return {
        artwork,
        imageId: imageMap[artworkId],
      };
    })
    .filter(({ imageId }) => imageId);
  const timeAgo = Utils.elapsedTime(new Date(createdAt).getTime());

  return (
    <div
      className="community-artlist-card__container"
      onClick={() => navigate(`/artlist/${artlist._id}`, { state: { from: true } })}
    >
      <CardHeader
        image={actor?.image}
        profileType={actor?.profileType}
        username={actor?.username}
        onUserClick={() => navigate(`/user/${actor?.username}`)}
        timeAgo={timeAgo}
        subtitle={
          <>{t('activity.artlist')} <span className="artlist-name">{artlist.artlist_title}</span></>
        }
      />
      <ArtlistImage
        image={artlist.artlist_image?.image_id}
        className="community-artlist-card__cover"
      />
      <div className="community-artlist-card__artworks-slider">
        {artworksWithImages.map(({ artwork, imageId }) => (
          <ArtworkImage
            key={typeof artwork === 'string' ? artwork : artwork._id}
            image={imageId}
            imageClassName="artlist-content__artwork-image"
            imageTemplateClassName="artlist-content__artwork-image-template"
            forceSmaller={350}
            onClick={(e) => {
              e.stopPropagation();
              const slug = typeof artwork === 'string' ? artwork : artwork.slug || artwork._id;
              navigate(`/artwork/${slug}`, {
                state: {
                  from: true,
                  artworkViewSource: {
                    type: 'artlist',
                    label: 'Artlist',
                  },
                }
              });
            }}
            artworkData={typeof artwork === 'string' ? undefined : artwork}
          />
        ))}
        {totalArtworks > 7 && (
          <Link
            to={`/artlist/${artlist._id}`}
            className="no-underline"
            onClick={(e) => e.stopPropagation()}
          >
            <ContinueButton className="community-artlist-card__see-all-button" link>
              <Text className="font-size-medium">{tHome('see_all')}</Text>
            </ContinueButton>
          </Link>
        )}
      </div>
    </div>
  );
}
